import { normalizeList } from '../../../lib/admin-api/index.js';
import { normalizeSupportAccessDateTime } from '../model/support-access.model.js';

function asStringOrNull(value) {
  if (value === null || value === undefined) {
    return null;
  }

  return String(value);
}

function normalizeGrants(payload) {
  if (!payload || typeof payload !== 'object') {
    return normalizeList(payload);
  }

  if (Array.isArray(payload.grants)) {
    return payload.grants;
  }

  if (payload.grants && typeof payload.grants === 'object') {
    return Object.values(payload.grants);
  }

  return normalizeList(payload);
}

function mapSupportAccessGrantToDto(item, index = 0) {
  return {
    id: String(item?.id ?? item?.uid ?? `support-access-${index}`),
    username: String(item?.username || '').trim(),
    label: String(item?.label || '').trim(),
    accessLevel: String(item?.accessLevel || item?.access_level || '').trim(),
    accessLevelLabel: String(item?.accessLevelLabel || item?.access_level_label || '').trim(),
    status: String(item?.status || '').trim(),
    expiresAt: asStringOrNull(item?.expiresAt ?? item?.expires_at),
    inviteExpiresAt: asStringOrNull(item?.inviteExpiresAt ?? item?.invite_expires_at),
    inviteConsumedAt: asStringOrNull(item?.inviteConsumedAt ?? item?.invite_consumed_at),
    lastLoginAt: asStringOrNull(item?.lastLoginAt ?? item?.last_login_at),
    createdBy: asStringOrNull(item?.createdBy ?? item?.created_by),
    createdAt: asStringOrNull(item?.createdAt ?? item?.created_at),
  };
}

export function mapSupportAccessResponseToDto(payload) {
  return normalizeGrants(payload).map((item, index) => mapSupportAccessGrantToDto(item, index));
}

export function mapSupportAccessInviteResponseToDto(payload) {
  return {
    grant: payload?.grant ? mapSupportAccessGrantToDto(payload.grant) : null,
    inviteUrl: String(payload?.inviteUrl || payload?.invite_url || '').trim(),
  };
}

export function mapSupportAccessGrantFormToPayload(form) {
  return {
    label: String(form?.label || '').trim(),
    accessLevel: String(form?.accessLevel || '').trim(),
    expiresAt: normalizeSupportAccessDateTime(form?.expiresAt),
    reason: String(form?.reason || '').trim(),
  };
}
